module.exports = __webpack_public_path__ + "img/angledEdge.0764ed29.svg";